import { useQuery, useMutation, useQueryClient } from "@tanstack/react-query";
import { getRouteApi } from "@tanstack/react-router";
import { api } from "#/lib/api";
import type { AuthUser, AuthMeResponse } from "@myapp/shared";

const rootRouteApi = getRouteApi("__root__");

export async function fetchAuthUser(): Promise<AuthUser | null> {
  try {
    const { data } = await api.get<AuthMeResponse>("/auth/me");
    return data.user;
  } catch {
    return null;
  }
}

export function useAuthUser() {
  const { user: loaderUser } = rootRouteApi.useLoaderData();

  return useQuery<AuthUser | null, Error>({
    queryKey: ["auth", "me"],
    queryFn: fetchAuthUser,
    initialData: loaderUser ?? undefined,
    retry: false,
    refetchOnWindowFocus: false,
    staleTime: 5 * 60 * 1000,
  });
}

export function useLogout() {
  const queryClient = useQueryClient();

  return useMutation<{ success: boolean }, Error>({
    mutationFn: async () => {
      const { data } = await api.post("/auth/logout");
      return data;
    },
    onSuccess: () => {
      queryClient.setQueryData(["auth", "me"], null);
      window.location.href = "/";
    },
  });
}
